// import { useTranslation } from "react-i18next";
import { UserLayout } from "../layouts/index";
import { NotFound } from "../pages";
// import { adminRoutes } from "./Admin/index";
import { userRoutes } from "./User/index";

export const routes = () => {
  // const { t } = useTranslation();
  return [
    {
      element: <UserLayout />,
      children: [...userRoutes()],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ];
};

export const routesList = () => {
  // const { t } = useTranslation();
  let routeArr = [...userRoutes()[0].children, ...userRoutes()[1].children];
  return [...routeArr];
};

export const moduleRoutesList = () => {
  // const { t } = useTranslation();
  let routeArr = {
    // admin: [...adminRoutes()[0].children, ...adminRoutes(t)[1].children],
    user: [...userRoutes()[0].children, ...userRoutes()[1].children],
  };
  return routeArr;
};

export const getCompletePathList = () => {
  return routesList().reduce((prev, curr) => {
    prev.push(curr);
    if (curr.children) {
      prev.push(...curr.children);
    }
    return prev;
  }, []);
};
